const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const getToken = () => localStorage.getItem('adminToken');

const req = async (method, endpoint, body = null) => {
  const res = await fetch(`${BASE}${endpoint}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(getToken() && { Authorization: `Bearer ${getToken()}` }),
    },
    ...(body && { body: JSON.stringify(body) }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Request failed');
  return data;
};

// Auth
export const adminLogin = (data) => req('POST', '/auth/login', data);

// Dashboard
export const getStats = () => req('GET', '/admin/stats');

// Users
export const getUsers       = () => req('GET', '/admin/users');
export const deleteUser     = (id) => req('DELETE', `/admin/users/${id}`);
export const updateUserRole = (id, role) => req('PUT', `/admin/users/${id}/role`, { role });

// Jobs
export const getJobs   = () => req('GET', '/jobs?limit=100');
export const deleteJob = (id) => req('DELETE', `/jobs/${id}`);
export const toggleJob = (id, isActive) => req('PUT', `/jobs/${id}`, { isActive });

// Applications
export const getApplications  = () => req('GET', '/admin/applications');
export const updateAppStatus  = (id, status) => req('PUT', `/applications/${id}/status`, { status });

// Contacts
export const getContacts  = () => req('GET', '/contact');
export const markAsRead   = (id) => req('PUT', `/contact/${id}/read`);
